__turbopack_context__.v({
  "overlay": "BlurOverlay-module-scss-module__cyMdMW__overlay",
  "visible": "BlurOverlay-module-scss-module__cyMdMW__visible",
});
